import Skeleton from 'react-loading-skeleton';

import { brandColors } from '@/app/constants';

const MemberProfileLoader = () => {
  return (
    <div className="grid gap-4">
      <Skeleton height={108} baseColor={brandColors.lightSilver} />

      <div className="grid grid-cols-4 gap-4">
        <div className="col-span-1">
          <Skeleton height={234} baseColor={brandColors.lightSilver} />
        </div>
        <div className="col-span-3">
          <Skeleton height={234} baseColor={brandColors.lightSilver} />
        </div>
      </div>

      <Skeleton height={234} baseColor={brandColors.lightSilver} />
    </div>
  );
};

export default MemberProfileLoader;
